// extracted by css-extract-rspack-plugin
var _1 = "r7XEV8cnMUYRfWm0";
var _2 = "_IDtfFzDAyIob8v1";
var _3 = "FzvEkFYHcqsi_77a";
var _4 = "LgQbPSj7js4LFYfL";
var _5 = "LgQbPSj7js4LFYfL";
var _6 = "HrRkgCmuI6IzAKPv";
export { _1 as "container", _2 as "header", _3 as "identifier", _4 as "stat-item", _5 as "statItem", _6 as "title" }
